import React from "react";
import {
  makeStyles,
  Container,
  Modal,
  Grid,
  Typography,
} from "@material-ui/core";

interface PropTypesI {
  title?: string;
  description?: string | React.ReactNode;
  onClose?: React.Dispatch<React.SetStateAction<boolean>>;
  visible: boolean;
  onSubmit?: Function;
  children?: React.ReactNode;
  modalWidth?: string;
  changePaddingLeft?: boolean;
}
const ButtonArea = ({ children, style }: { children?: React.ReactNode; style?: React.CSSProperties }) => (
  <Grid
    item
    container
    xs={12}
    justifyContent="flex-end"
    style={{ paddingTop: 14, gap: 16, ...style }}
  >
    {children}
  </Grid>
);

const ContentArea = ({ children, className }: { children?: React.ReactNode, className?: string }) => (
  <Grid item xs={12} className={className}>
    {children}
  </Grid>
);
const GeneralModal = (props: PropTypesI) => {
  const classes = useStyles(props.modalWidth, props.changePaddingLeft)();

  return (
    <Modal
      open={props.visible}
      onClose={props.onClose}
      className={classes.modal}
    >
      <Container className={classes.modalContainer}>
        <Grid container spacing={1}>
          <Grid item>
            <Typography
              variant="h6"
              component="h6"
              color="textPrimary"
              className={classes.modalTitle}
            >
              {props.title}
            </Typography>
          </Grid>
          <Grid item style={{ minWidth: 420 }}>
            {typeof props.description === "function" ? props.description() :
              <Typography
                style={{ whiteSpace: "pre-line" }}
                variant="body2"
                component="span"
                color="textPrimary">
                {props.description}
              </Typography>
            }
          </Grid>
          {props?.children ?? <></>}
        </Grid>
      </Container>
    </Modal>
  );
};
GeneralModal.ButtonArea = ButtonArea;
GeneralModal.ContentArea = ContentArea;
export default GeneralModal;

const useStyles = (modalWidth, changePaddingLeft) =>
  makeStyles({
    modal: { alignItems: "center", justifyContent: "center" },
    modalContainer: {
      width: modalWidth ?? "480px",
      height: "auto",
      backgroundColor: "white",
      boxShadow:
        "0px 6px 36px rgba(0, 0, 0, 0.15), 0px 2.21728px 14.2392px rgba(0, 0, 0, 0.111884), 0px 0.93179px 6.99399px rgba(0, 0, 0, 0.0997219), 0px 0.37078px 3.36556px rgba(0, 0, 0, 0.0894965), 0px 0.120827px 1.42249px rgba(0, 0, 0, 0.0753326), 0px 0.0225271px 0.422798px rgba(0, 0, 0, 0.0508791)",
      borderRadius: "20px",
      padding: changePaddingLeft ? "24px 24px 24px 0px" : "24px",
      margin: "0",
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
    },
    modalTitle: {
      paddingLeft: changePaddingLeft ? 24 : 0,
    },
  });
